import React, { useEffect, useState } from "react";
import css from "./Header.module.css";
import logo from "../../assets/logo.png";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { BiPhoneCall } from "react-icons/bi";
import { FiMail } from "react-icons/fi";

const Header = () => {
  const navigate = useNavigate();
  const [isSticky, setIsSticky] = useState(false);
  const [click, setClick] = useState(false);
  const navItems = [
    { to: "/", label: "Home", offset: -40 },
    { to: "about-us", label: "About Us", offset: -110 },
    { to: "courses", label: "Courses", offset: -80 },
    { to: "teams", label: "Faculty", offset: -40 },
    { to: "admissions", label: "Admissions", offset: -40 },
    { to: "facilities", label: "Facilities", offset: -60 },
  ];

  const handleClick = () => {
    setClick(!click);
  };

  const closeMenu = () => {
    setClick(false);
  };

  const goToHome = () => {
    navigate("/");
    closeMenu();
  };

  useEffect(() => {
    const headerBottom = document.getElementById("header_bottom");
    if (!headerBottom) return undefined;
    const headerBottomTop = headerBottom.offsetTop;

    const handleScroll = () => {
      const shouldStick = window.scrollY > headerBottomTop;
      setIsSticky(shouldStick);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className={css.header} id="/">
        <div className={css.header_top}>
          <a
            href="tel:+91 6005787874"
            className={css.top_links}>
            <BiPhoneCall color="rgba(255, 145, 76, 1)" />
            <span className={css.top_link}>+91-6005787874</span>
          </a>
          <a
            href="mailto:info@abhyaasiit.com"
            className={css.top_links}>
            <FiMail color="rgba(255, 145, 76, 1)" />
            <span className={css.top_link}>info@abhyaasiit.com</span>
          </a>
          <a
            href="https://wa.me/916005787874?text=Hello,%20I%20want%20to%20chat!"
            target="_blank"
            rel="noreferrer"
            className={css.top_links}>
            <FaWhatsapp color="rgba(255, 145, 76, 1)" />
            <span className={css.top_link}>91-6005787874</span>
          </a>
        </div>
        <div
          className={
            isSticky ? `${css.header_bottom} ${css.sticky}` : css.header_bottom
          }
          id="header_bottom">
          <div className={css.nav_shell}>
          <div className={css.left}>
            <Link
              to="/"
              activeClass="active"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}>
              <img
                src={logo}
                alt="logo_img"
                onClick={goToHome}
                className={css.logo}
              />
            </Link>
          </div>
          <div className={css.center}>
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                activeClass="active"
                spy={true}
                smooth={true}
                offset={item.offset}
                duration={500}>
                <p className={css.para}>{item.label}</p>
              </Link>
            ))}
          </div>
          <div className={css.right}>
            <Link
              to="footer"
              activeClass="active"
              spy={true}
              smooth={true}
              offset={-40}
              duration={500}>
              <button className={css.btn}>CONTACT US</button>
            </Link>
          </div>
          </div>
        </div>
      </div>
      <div className={css.mbl_header}>
        <div className={css.mbl_logo}>
          <img
            src={logo}
            alt="Logo"
            onClick={goToHome}
            className={css.mbl_logo_img}
          />
        </div>
        <div
          className={
            click ? `${css.mbl_menu} ${css.open}` : css.mbl_menu_hidden
          }>
          <div className={css.mbl_menu_inner}>
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                activeClass="active"
                spy={true}
                smooth={true}
                offset={item.offset}
                duration={500}
                onClick={closeMenu}>
                <p className={css.mbl_para}>{item.label}</p>
              </Link>
            ))}

            <div className={css.mbl_Links}>
              <h4 className={css.contact_title}>Get in touch</h4>

              <div className={css.link_imgs}>
                <a
                  href="tel:+91 6005787874"
                  className={css.mbl_contact_link}>
                  <BiPhoneCall size={22} color="rgba(255, 145, 76, 1)" />
                </a>
                <a
                  href="mailto:info@abhyaasiit.com"
                  className={css.mbl_contact_link}>
                  <FiMail size={22} color="rgba(255, 145, 76, 1)" />
                </a>
                <a
                  href="https://wa.me/916005787874?text=Hello,%20I%20want%20to%20chat!"
                  target="_blank"
                  rel="noreferrer"
                  className={css.mbl_contact_link}>
                  <FaWhatsapp size={22} color="rgba(255, 145, 76, 1)" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <button className={css.hamburger} onClick={handleClick} type="button">
          <span className={click ? `${css.bar} ${css.barTopOpen}` : css.bar} />
          <span className={click ? `${css.bar} ${css.barMiddleOpen}` : css.bar} />
          <span className={click ? `${css.bar} ${css.barBottomOpen}` : css.bar} />
        </button>
      </div>
    </>
  );
};

export default Header;
